<template>
    <div class="card">
        <!-- <div class="card-header">Featured</div> -->
        <div class="card-body p-3">
            <!-- <h6 class="card-title">Axtaris ucun daxil edin</h6> -->
            <!-- <p class="card-text"></p> -->
            <div class="input-group">
                <!-- <button class="btn btn-outline-secondary" type="button" id="button-addon1">Button</button> -->
                <a href="#" class="btn">
                    <i class="fas fa-search"></i>
                </a>
                <input
                    type="text"
                    class="form-control rounded-pill"
                    placeholder
                    aria-label="Example text with button addon"
                    aria-describedby="button-addon1"
                />
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'HeaderSearchBar',
        setup() {
            return  {};
        },
    };
</script>

<style lang="scss">
</style>